import React from 'react'

import styled, { keyframes } from 'styled-components'

import FreeRounds from '../../Icons/FreeRounds'
import withCondition from '../../withCondition'
import GameIcon from './GameIcon'

const anim = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
`

const StyledIcon = styled(FreeRounds)`
  & > #spin {
    animation: 3s ${anim} cubic-bezier(0.26, 1.43, 0.65, 1) forwards infinite;
    transform-origin: center;
  }
`

function FreeRoundsIcon() {
  return (
    <GameIcon
      Icon={StyledIcon}
      className="free-rounds-icon"
      corner="right-top"
    />
  )
}

export default withCondition(FreeRoundsIcon)
